import Header from '@/components/Header';
import Hero from '@/components/Hero';
import PositioningStrip from '@/components/PositioningStrip';
import Capabilities from '@/components/Capabilities';
import Approach from '@/components/Approach';
import SelectWork from '@/components/SelectWork';
import Principles from '@/components/Principles';
import Contact from '@/components/Contact';
import ScrollProgress from '@/components/ScrollProgress';

export default function App() {
  return (
    <div className="min-h-screen bg-paper text-ink antialiased selection:bg-accent/20 selection:text-ink">
      <ScrollProgress />
      <Header />
      <main>
        <Hero />
        <PositioningStrip />
        <Capabilities />
        <Approach />
        <SelectWork />
        <Principles />
        <Contact />
      </main>
    </div>
  );
}
